<ifc-base-dialog [title]="data?.title"
                 [actions]="actions"
                 (actionClicked)="onActionClicked($event)">
  <ng-template #content>
    <mat-form-field appearance="outline"
                    class="field">
      <mat-label>Loan</mat-label>
      <mat-select matInput
                  [(ngModel)]="selected"
                  name="Loan">
        <mat-select-trigger>{{ selected?.label }}</mat-select-trigger>
        <mat-option *ngFor="let loanOption of loanOptions"
                    [value]="loanOption">
          <mat-icon *ngIf="loanOption.iconName"
                    [ngClass]="loanOption.iconClass"
                    [matTooltipClass]="'mat-tooltip status-tooltip-'+loanOption.iconName"
                    [matTooltip]="loanOption.iconTooltip">{{loanOption.iconName}}</mat-icon>
          <span #label
                class="loan-description"
                matTooltipClass="mat-tooltip"
                [matTooltipDisabled]="shouldShowTooltip(label)"
                [matTooltip]="loanOption.tooltip">{{ loanOption.label }}</span>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </ng-template>
</ifc-base-dialog>
